export default __webpack_public_path__ + "static/media/discounts-5off20-image.6205ff57.svg";